// Layouts

// Styles
import './bulkRefund.scss';

// Components
import BulkRefundHeader from './BulkRefundHeader';
import BulkRefundTable from './BulkRefundTable';
import BulkRefundFileView from './BulkRefundFileView';

// Redux
import { uploadBulkUploadFileRequest } from './redux/bulkRefund.actions';

// Libraries
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

const BulkRefund = ({ auth, actions }) => {
    const uploadFile = formData => {
        actions.uploadBulkUploadFileRequest(formData);
    };

    const { userLevel } = auth.userDetails;

    return (
        <div className="bulk-refund-wrapper">
            <Switch>
                <Route exact path="/bulk-refund">
                    <BulkRefundHeader
                        uploadFile={uploadFile}
                        userLevel={userLevel}
                    />
                    <BulkRefundTable />
                </Route>
                <Route path="/bulk-refund/:batchId">
                    <BulkRefundFileView />
                </Route>
            </Switch>
        </div>
    );
};

const mapStateToProps = ({ auth, loader, actions }) => ({
    auth,
    loader,
    actions,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            uploadBulkUploadFileRequest,
        },
        dispatch
    ),
});

BulkRefund.propTypes = {
    actions: PropTypes.object,
    auth: PropTypes.object,
    loader: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps)(BulkRefund);
